import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const userIndexFundSelector = ({ userIndexFund }: ReducerState) => userIndexFund;
export const userIndexFundLoadingSelector = createSelector(
  userIndexFundSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
